module.exports = __webpack_public_path__ + "static/LuciaA-7deccdd9a5d6adf5a2493e27ef865881.gif";